var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import { Button, Checkbox, ConfirmationModal, MessageBanner, Modal, ModalFooter, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { RecekSelection, RecekTextArea, RecekTextField } from "./inputs";
import { buildPersonOptionLabel, usePersonOptions, } from "../hooks/title/usePersonOptions";
import { isPersonUnlinked } from "../utils/personAuthorityLink";
import { PersonTitlesPreview } from "./PersonTitlesPreview";
/**
 * Detail action-menu items linking a local-only person to NK authorities
 * (DB-635) and merging duplicates into the person (DB-653). Renders nothing
 * unless the user may manage the link. Send / NK identifier / merge only for a
 * person not linked yet: send for a local-only person or one whose last send
 * failed, merge also for an import proposal (dummyId); an already sent person
 * only gets its NK identifier. "Sloučit duplicity" for any person.
 * "Navrhnout sloučení" (DB-756) only for a person linked to NK authorities.
 */
export var PersonAuthorityLinkMenuItems = function (_a) {
    var link = _a.link, onToggle = _a.onToggle;
    if (!link.canManage && !link.canMergeDuplicates && !link.canProposeMerge) {
        return null;
    }
    var run = function (action) { return function () {
        onToggle === null || onToggle === void 0 ? void 0 : onToggle();
        action();
    }; };
    return (React.createElement(React.Fragment, null,
        link.canSend && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: run(link.sendToAuthority), disabled: link.isBusy, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.send.button" }))),
        link.canManage && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: run(link.assign.open), disabled: link.isBusy, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.assign.button" }))),
        link.canMerge && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: run(link.merge.open), disabled: link.isBusy, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.merge.button" }))),
        link.canMergeDuplicates && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: run(link.duplicates.open), disabled: link.isBusy, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.duplicates.button" }))),
        link.canProposeMerge && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: run(link.propose.open), disabled: link.isBusy, fullWidth: true },
            React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.proposeMerge.button" })))));
};
/**
 * "Odeslat do NA" for a natural person without a biographical note (AC9): asks
 * for the note, which is stored on the person and sent right away.
 */
var SendWithBiographicalNoteModal = function (_a) {
    var link = _a.link;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(""), note = _b[0], setNote = _b[1];
    var send = link.send;
    useEffect(function () {
        if (send.isOpen)
            setNote("");
    }, [send.isOpen]);
    var submit = function () { return send.submit(note); };
    return (React.createElement(Modal, { open: send.isOpen, onClose: send.close, label: formatMessage({
            id: "ui-br-agency.person.authorityLink.send.withNote.title",
        }), size: "medium", dismissible: true, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: submit, disabled: link.isBusy },
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.send.withNote.submit" })),
            React.createElement(Button, { onClick: send.close, disabled: link.isBusy },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))) },
        send.error && (React.createElement(MessageBanner, { type: "error" },
            React.createElement("div", null, send.error))),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.send.withNote.info" })),
        React.createElement(RecekTextArea, { labelId: "ui-br-agency.natural-person.biographicalNote.field.label", value: note, onChange: function (e) {
                return setNote(e.target.value);
            }, required: true, autoFocus: true })));
};
var AssignAuthorityIdModal = function (_a) {
    var link = _a.link;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(""), authorityId = _b[0], setAuthorityId = _b[1];
    var assign = link.assign;
    useEffect(function () {
        if (assign.isOpen)
            setAuthorityId("");
    }, [assign.isOpen]);
    var submit = function () { return assign.submit(authorityId); };
    return (React.createElement(Modal, { open: assign.isOpen, onClose: assign.close, label: formatMessage({
            id: "ui-br-agency.person.authorityLink.assign.modal.title",
        }), size: "small", dismissible: true, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: submit, disabled: link.isBusy },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })),
            React.createElement(Button, { onClick: assign.close, disabled: link.isBusy },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))) },
        assign.error && (React.createElement(MessageBanner, { type: "error" },
            React.createElement("div", null, assign.error),
            assign.conflictingPersonId && link.canMerge && (React.createElement(Button, { buttonStyle: "link", onClick: assign.mergeIntoConflictingPerson, marginBottom0: true },
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.assign.mergeInstead" }))))),
        React.createElement("form", { noValidate: true, onSubmit: function (e) {
                e.preventDefault();
                submit();
            } },
            React.createElement(RecekTextField, { labelId: "ui-br-agency.person.authorityLink.assign.field.label", value: authorityId, onChange: function (e) {
                    return setAuthorityId(e.target.value);
                }, required: true, autoFocus: true }))));
};
var MergePersonModal = function (_a) {
    var _b;
    var link = _a.link;
    var formatMessage = useIntl().formatMessage;
    var merge = link.merge, person = link.person, legalForm = link.legalForm;
    var _c = useState(false), confirming = _c[0], setConfirming = _c[1];
    var _d = usePersonOptions(), personOptions = _d.personOptions, onPersonFilter = _d.onPersonFilter, clearPersonFilter = _d.clearPersonFilter, personOptionsLoading = _d.personOptionsLoading, findPersonById = _d.findPersonById, personSearchResults = _d.personSearchResults;
    // Reset the search and the confirmation step each time the modal opens (only then).
    useEffect(function () {
        if (merge.isOpen) {
            setConfirming(false);
            clearPersonFilter();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [merge.isOpen]);
    var target = merge.target;
    // A target preselected from a duplicate NK identifier (-81) is resolved
    // asynchronously; until then it gets a neutral placeholder, never its id.
    var _e = useMemo(function () {
        var _a, _b;
        if (!target)
            return { targetLabel: "", targetResolved: true };
        var found = (_b = (_a = findPersonById(target.id)) !== null && _a !== void 0 ? _a : personSearchResults.find(function (p) { return p.id === target.id; })) !== null && _b !== void 0 ? _b : target.person;
        return found
            ? {
                targetLabel: buildPersonOptionLabel(__assign(__assign({}, found), { legalForm: legalForm })),
                targetResolved: true,
            }
            : {
                targetLabel: formatMessage({ id: "ui-br-agency.loading" }),
                targetResolved: false,
            };
        // findPersonById reads a ref cache that is filled together with personOptions
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, legalForm, personOptions, personSearchResults]), targetLabel = _e.targetLabel, targetResolved = _e.targetResolved;
    var options = useMemo(function () {
        var withoutSelf = personOptions.filter(function (option) { return option.value !== (person === null || person === void 0 ? void 0 : person.id); });
        if (target && !withoutSelf.some(function (option) { return option.value === target.id; })) {
            return __spreadArray([{ value: target.id, label: targetLabel }], withoutSelf, true);
        }
        return withoutSelf;
    }, [personOptions, person === null || person === void 0 ? void 0 : person.id, target, targetLabel]);
    var close = function () {
        setConfirming(false);
        merge.close();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { open: merge.isOpen && !confirming, onClose: close, label: formatMessage({
                id: "ui-br-agency.person.authorityLink.merge.modal.title",
            }), size: "medium", dismissible: true, footer: React.createElement(ModalFooter, null,
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return setConfirming(true); }, disabled: !target || !targetResolved || link.isBusy },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.merge.continue" })),
                React.createElement(Button, { onClick: close, disabled: link.isBusy },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))) },
            merge.error && (React.createElement(MessageBanner, { type: "error" }, merge.error)),
            React.createElement(RecekSelection
            // The selection keeps the label it rendered the selected value with;
            // remount it once a preselected target is resolved so its name shows.
            , { 
                // The selection keeps the label it rendered the selected value with;
                // remount it once a preselected target is resolved so its name shows.
                key: targetResolved ? "resolved" : "pending", labelId: "ui-br-agency.person.authorityLink.merge.field.label", dataOptions: options, asyncFilter: true, onFilter: function (name) { return onPersonFilter(name, legalForm); }, value: (_b = target === null || target === void 0 ? void 0 : target.id) !== null && _b !== void 0 ? _b : "", onChange: function (id) { return merge.setTarget(id ? { id: id } : null); }, loading: personOptionsLoading })),
        React.createElement(ConfirmationModal, { open: merge.isOpen && confirming, heading: formatMessage({
                id: "ui-br-agency.person.authorityLink.merge.confirm.heading",
            }), message: formatMessage({ id: "ui-br-agency.person.authorityLink.merge.confirm.message" }, { target: targetLabel }), onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!target) return [3 /*break*/, 2];
                            return [4 /*yield*/, merge.submit(target.id)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            setConfirming(false);
                            return [2 /*return*/];
                    }
                });
            }); }, onCancel: function () { return setConfirming(false); }, confirmLabel: formatMessage({
                id: "ui-br-agency.person.authorityLink.merge.confirm.button",
            }), cancelLabel: formatMessage({ id: "ui-br-agency.button.cancel" }), buttonStyle: "danger", isConfirmButtonDisabled: link.isBusy })));
};
/**
 * "Sloučit duplicity" (DB-653): offers the likely duplicates of the opened
 * person (same normalized name, eligible to be merged) as checkboxes, lets the
 * user search and add further unlinked persons of the same type and, after a
 * confirmation, merges all checked ones into the opened person at once.
 * Each listed person shows its titles so namesakes can be told apart (DB-681).
 */
var MergeDuplicatesModal = function (_a) {
    var _b;
    var link = _a.link;
    var formatMessage = useIntl().formatMessage;
    var duplicates = link.duplicates, person = link.person, legalForm = link.legalForm;
    var _c = useState([]), selected = _c[0], setSelected = _c[1];
    var _d = useState([]), added = _d[0], setAdded = _d[1];
    var _e = useState(false), confirming = _e[0], setConfirming = _e[1];
    var _f = usePersonOptions(), onPersonFilter = _f.onPersonFilter, clearPersonFilter = _f.clearPersonFilter, personOptionsLoading = _f.personOptionsLoading, personSearchResults = _f.personSearchResults;
    // Start from a clean selection each time the modal opens (only then).
    useEffect(function () {
        if (duplicates.isOpen) {
            setSelected([]);
            setAdded([]);
            setConfirming(false);
            clearPersonFilter();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [duplicates.isOpen]);
    var label = function (p) {
        return buildPersonOptionLabel(__assign(__assign({}, p), { legalForm: legalForm }));
    };
    var personLabel = label(person);
    var candidates = useMemo(function () {
        return duplicates.candidates
            .filter(function (c) { return c.id && c.id !== (person === null || person === void 0 ? void 0 : person.id); })
            .map(function (c) { return ({
            id: c.id,
            label: label(c) || c.id,
        }); });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [duplicates.candidates, person === null || person === void 0 ? void 0 : person.id, legalForm]);
    var entries = useMemo(function () { return __spreadArray(__spreadArray([], candidates, true), added.filter(function (a) { return !candidates.some(function (c) { return c.id === a.id; }); }), true); }, [candidates, added]);
    // Search results: persons of the same type without an NK identifier, not
    // listed yet. Derived from the search data itself (rendered together with
    // it). The search does not carry localOnly / the send error, so a person
    // sent to NK that awaits its identifier can still be picked; the backend
    // then rejects it (-84) naming it.
    var searchOptions = useMemo(function () {
        return personSearchResults
            .filter(function (found) {
            return found.id !== (person === null || person === void 0 ? void 0 : person.id) &&
                isPersonUnlinked(found) &&
                !entries.some(function (e) { return e.id === found.id; });
        })
            .map(function (found) { return ({ value: found.id, label: label(found) || found.id }); });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [personSearchResults, person === null || person === void 0 ? void 0 : person.id, entries, legalForm]);
    var toggle = function (id) {
        return setSelected(function (current) {
            return current.includes(id) ? current.filter(function (s) { return s !== id; }) : __spreadArray(__spreadArray([], current, true), [id], false);
        });
    };
    var addFromSearch = function (id) {
        if (!id || entries.some(function (e) { return e.id === id; }))
            return;
        var option = searchOptions.find(function (o) { return o.value === id; });
        setAdded(function (current) { return __spreadArray(__spreadArray([], current, true), [{ id: id, label: (option === null || option === void 0 ? void 0 : option.label) || id }], false); });
        setSelected(function (current) { return __spreadArray(__spreadArray([], current, true), [id], false); });
        clearPersonFilter();
    };
    // Merge order = listed order: an empty field is filled from the first one.
    var chosen = entries.filter(function (e) { return selected.includes(e.id); });
    var errorPersonLabel = duplicates.errorPersonId
        ? (_b = entries.find(function (e) { return e.id === duplicates.errorPersonId; })) === null || _b === void 0 ? void 0 : _b.label
        : undefined;
    var close = function () {
        setConfirming(false);
        duplicates.close();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Modal, { open: duplicates.isOpen && !confirming, onClose: close, label: formatMessage({
                id: "ui-br-agency.person.authorityLink.duplicates.modal.title",
            }), size: "large", dismissible: true, footer: React.createElement(ModalFooter, null,
                React.createElement(Button, { buttonStyle: "primary", onClick: function () { return setConfirming(true); }, disabled: chosen.length === 0 || link.isBusy },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.merge.continue" })),
                React.createElement(Button, { onClick: close, disabled: link.isBusy },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))) },
            duplicates.error && (React.createElement(MessageBanner, { type: "error" },
                React.createElement("div", null, duplicates.error),
                errorPersonLabel && (React.createElement("div", null,
                    React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.duplicates.error.person", values: { name: errorPersonLabel } }))))),
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.duplicates.info", values: { target: personLabel } })),
            React.createElement("h4", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.duplicates.candidates.heading" })),
            duplicates.candidatesError && (React.createElement(MessageBanner, { type: "error" },
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.duplicates.candidates.error" }))),
            duplicates.candidatesLoading && (React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.loading" }))),
            !duplicates.candidatesLoading &&
                !duplicates.candidatesError &&
                entries.length === 0 && (React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.duplicates.candidates.empty" }))),
            entries.map(function (entry) { return (React.createElement("div", { key: entry.id },
                React.createElement(Checkbox, { label: entry.label, checked: selected.includes(entry.id), onChange: function () { return toggle(entry.id); } }),
                React.createElement(PersonTitlesPreview, { kind: link.kind, personId: entry.id }))); }),
            React.createElement(RecekSelection, { labelId: "ui-br-agency.person.authorityLink.duplicates.search.label", dataOptions: searchOptions, asyncFilter: true, onFilter: function (name) { return onPersonFilter(name, legalForm); }, value: "", onChange: addFromSearch, loading: personOptionsLoading })),
        React.createElement(ConfirmationModal, { open: duplicates.isOpen && confirming, heading: formatMessage({
                id: "ui-br-agency.person.authorityLink.duplicates.confirm.heading",
            }), message: formatMessage({
                id: "ui-br-agency.person.authorityLink.duplicates.confirm.message",
            }, {
                count: chosen.length,
                target: personLabel,
                names: chosen.map(function (c) { return c.label; }).join("; "),
            }), onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, duplicates.submit(chosen.map(function (c) { return c.id; }))];
                        case 1:
                            _a.sent();
                            setConfirming(false);
                            return [2 /*return*/];
                    }
                });
            }); }, onCancel: function () { return setConfirming(false); }, confirmLabel: formatMessage({
                id: "ui-br-agency.person.authorityLink.merge.confirm.button",
            }), cancelLabel: formatMessage({ id: "ui-br-agency.button.cancel" }), buttonStyle: "danger", isConfirmButtonDisabled: link.isBusy })));
};
/** Longest note the backend accepts for a merge proposal (DB-756). */
export var PROPOSE_MERGE_NOTE_MAX_LENGTH = 4000;
/**
 * "Navrhnout sloučení" (DB-756): two NK authorities can only be merged by the
 * NK authority department. The user picks the target authority of the same
 * type (only persons linked to NK, never the opened one) and may add a note;
 * the proposal that the opened authority disappears and the target stays is
 * e-mailed to the department. Nothing changes in ReČeK, so no confirmation.
 */
var ProposeMergeModal = function (_a) {
    var _b, _c;
    var link = _a.link;
    var formatMessage = useIntl().formatMessage;
    var propose = link.propose, person = link.person, legalForm = link.legalForm;
    var _d = useState(null), target = _d[0], setTarget = _d[1];
    var _e = useState(""), note = _e[0], setNote = _e[1];
    var _f = usePersonOptions({ linkedOnly: true }), onPersonFilter = _f.onPersonFilter, clearPersonFilter = _f.clearPersonFilter, personOptionsLoading = _f.personOptionsLoading, personSearchResults = _f.personSearchResults;
    // Start from a clean form each time the modal opens (only then).
    useEffect(function () {
        if (propose.isOpen) {
            setTarget(null);
            setNote("");
            clearPersonFilter();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [propose.isOpen]);
    var label = function (p) {
        return buildPersonOptionLabel(__assign(__assign({}, p), { legalForm: legalForm }));
    };
    var personLabel = label(person);
    var ownSourceId = (_b = person === null || person === void 0 ? void 0 : person.sourceId) === null || _b === void 0 ? void 0 : _b.trim();
    // Only other persons of the same type linked to an NK authority (the backend
    // already searches linked ones only; kept as a safety net) with another NK
    // identifier; the chosen target stays listed while the user searches further.
    var options = useMemo(function () {
        var found = personSearchResults
            .filter(function (p) {
            var _a;
            return p.id !== (person === null || person === void 0 ? void 0 : person.id) &&
                !isPersonUnlinked(p) &&
                ((_a = p.sourceId) === null || _a === void 0 ? void 0 : _a.trim()) !== ownSourceId;
        })
            .map(function (p) { return ({ value: p.id, label: label(p) || p.id }); });
        return target && !found.some(function (o) { return o.value === target.id; })
            ? __spreadArray([{ value: target.id, label: target.label }], found, true) : found;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [personSearchResults, person === null || person === void 0 ? void 0 : person.id, ownSourceId, target, legalForm]);
    var choose = function (id) {
        if (!id) {
            setTarget(null);
            return;
        }
        var option = options.find(function (o) { return o.value === id; });
        setTarget({ id: id, label: (option === null || option === void 0 ? void 0 : option.label) || id });
    };
    var submit = function () {
        if (target) {
            propose.submit(target.id, note.trim());
        }
    };
    return (React.createElement(Modal, { open: propose.isOpen, onClose: propose.close, label: formatMessage({
            id: "ui-br-agency.person.authorityLink.proposeMerge.modal.title",
        }), size: "medium", dismissible: true, footer: React.createElement(ModalFooter, null,
            React.createElement(Button, { buttonStyle: "primary", onClick: submit, disabled: !target || link.isBusy },
                React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.proposeMerge.submit" })),
            React.createElement(Button, { onClick: propose.close, disabled: link.isBusy },
                React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" }))) },
        propose.error && (React.createElement(MessageBanner, { type: "error" }, propose.error)),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.proposeMerge.info", values: { person: personLabel } })),
        React.createElement(RecekSelection, { labelId: "ui-br-agency.person.authorityLink.proposeMerge.field.label", dataOptions: options, asyncFilter: true, onFilter: function (name) { return onPersonFilter(name, legalForm); }, value: (_c = target === null || target === void 0 ? void 0 : target.id) !== null && _c !== void 0 ? _c : "", onChange: choose, loading: personOptionsLoading, required: true }),
        target && (React.createElement(React.Fragment, null,
            React.createElement(PersonTitlesPreview, { kind: link.kind, personId: target.id }),
            React.createElement("ul", null,
                React.createElement("li", null,
                    React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.proposeMerge.summary.merged", values: { name: personLabel } })),
                React.createElement("li", null,
                    React.createElement(FormattedMessage, { id: "ui-br-agency.person.authorityLink.proposeMerge.summary.surviving", values: { name: target.label } }))))),
        React.createElement(RecekTextArea, { labelId: "ui-br-agency.person.authorityLink.proposeMerge.note.label", value: note, onChange: function (e) {
                return setNote(e.target.value.slice(0, PROPOSE_MERGE_NOTE_MAX_LENGTH));
            }, maxLength: PROPOSE_MERGE_NOTE_MAX_LENGTH })));
};
/**
 * Modals of the NK authority link actions (assign an NK identifier, merge into
 * an existing person, merge duplicates, propose a merge to NK). Render once next to the pane using
 * {@link PersonAuthorityLinkMenuItems}.
 */
export var PersonAuthorityLinkModals = function (_a) {
    var link = _a.link;
    return (React.createElement(React.Fragment, null,
        link.canManage && (React.createElement(React.Fragment, null,
            React.createElement(SendWithBiographicalNoteModal, { link: link }),
            React.createElement(AssignAuthorityIdModal, { link: link }),
            React.createElement(MergePersonModal, { link: link }))),
        link.canMergeDuplicates && React.createElement(MergeDuplicatesModal, { link: link }),
        link.canProposeMerge && React.createElement(ProposeMergeModal, { link: link })));
};
